import React from 'react';
import { Users, TrendingUp, Eye, Calendar, Phone, DollarSign, BarChart3, UserCheck } from 'lucide-react';
import DetailedChart from '../charts/DetailedChart'; // Fixed import - removed curly braces

const DetailedChartModal = ({ data, onClose }) => {
  if (!data) return null;

  const { title, value, campaignData, metricKey, chartType, color } = data;

  // Get the appropriate icon based on metricKey
  const getIcon = () => {
    switch(metricKey) {
      case 'invitations': return Users;
      case 'registrations': return TrendingUp;
      case 'attendees': return Eye;
      case 'bookings': return Calendar;
      case 'show': return Phone;
      case 'sales': return DollarSign;
      case 'inviteToReg': return TrendingUp;
      case 'regToAttend': return UserCheck;
      case 'attendToBook': return Phone;
      case 'bookedToShow': return Eye;
      case 'showToSale': return DollarSign;
      case 'revenue': return BarChart3;
      default: return BarChart3;
    }
  };

  const IconComponent = getIcon();

  // Handle backdrop click
  const handleBackdropClick = (e) => {
    // Only close if clicking the backdrop itself, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className={`p-2 rounded-lg bg-${color}-100 mr-4`}>
              <IconComponent className={`h-6 w-6 text-${color}-600`} />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
              <p className="text-lg text-gray-600">Detailed Analysis</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <div className="mb-8 text-center">
            <div className={`text-4xl font-bold text-${color}-600 mb-2`}>
              {value}
            </div>
            <p className="text-gray-600">Current Total Value</p>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Trend Analysis</h3>
            <DetailedChart 
              data={campaignData}
              metricKey={metricKey}
              chartType={chartType}
              color={color}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedChartModal;